<template>
  <div class="container-fluid mt-5">
    <div>
      <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">
                {{ $t("CATEGORY_EQUIPMENTS.CATEGORY_EQUIPMENTS_LIST") }}
              </h3>
            </div>
            <div class="col-6 text-right">
              <base-button
                type="primary"
                icon
                size="sm"
                @click="addCategoryEquipment()"
                v-if="$currentUserCan($permissions.PERM_CREATE_CATEGORY_EQUIPMENTS)"
              >
                <span class="btn-inner--icon">
                  <i class="fas fa-plus"></i>
                </span>
                <span class="btn-inner--text">{{
                  $t("CATEGORY_EQUIPMENTS.ADD_CATEGORY_EQUIPMENT")
                }}</span>
              </base-button>
            </div>
          </div>
        </template>

        <category-equipment-list-table />
      </card>
    </div>
  </div>
</template>
<script>
import { Button } from "element-ui";
import CategoryEquipmentListTable from "./partials/CategoryEquipmentListTable.vue";

export default {
  layout: "DashboardLayout",

  components: {
    CategoryEquipmentListTable,
    [Button.name]: Button,
  },

  mixins: [],

  computed: {},

  watch: {},

  methods: {
    addCategoryEquipment() {
      this.$router.push({ name: "Add CategoryEquipment" });
    },
  },
};
</script>
